import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { Satellite } from 'types';

export const getSatellites = async (): Promise<Satellite[]> => {
  const { data }: { data: Satellite[] } = await axios.get(`/api/satellites`);
  return data as Satellite[];
};

type QueryFnType = typeof getSatellites;

type UseSatellitesOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useSatellites = ({ config }: UseSatellitesOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['satellites'],
    queryFn: () => getSatellites(),
    ...config,
  });
};
